import OfferJobForm from "../../../../../components/forms/offerJobForm";
const UpdateJobs = () => {
    return (
        <div>
            <OfferJobForm title="Update Job Title,Company Name,Area,Type" btn="Update" back="/job-details" url="/company-profile" link="/update-job/"/>
        </div>
    )
}
export default UpdateJobs;